import {NgModule} from "@angular/core";
import {Http} from "@angular/http";

import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TranslateStore} from "@ngx-translate/core/src/translate.store";
import {environment} from "@environments/environment";

export function HttpLoaderFactory(http: Http) {
  return new TranslateHttpLoader(http, environment.i18nBaseUrl);
}

@NgModule({
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [Http]
      }
    }),
  ],
  exports: [
    TranslateModule
  ],
  providers: [TranslateStore]
})
export class i18nModule {

  constructor(translate: TranslateService) {
    translate.setDefaultLang('fr');
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/common/config/i18n.module.ts